
<template>
  <div class="review" :class="{scene: metrics}">

    <!-- LANDING -->
    <h3 class="title" v-show="!metrics">{{items.summary.title}}</h3>
    <p class="prompt" v-show="!metrics">{{items.summary.text}}</p>
      <div class="landing animated fadeIn" v-show="!metrics">
        <div class="step" v-for="(item, index) in items.activity.scenes" @click="select(index)">
          <div class="selected" v-show="step[index]">
            <i class="fas fa-check"></i>
          </div>
          <img :src="'media/page3/' + item.image" />
          <div class="holder" >
            <h3>{{item.title}}</h3>
            <p>{{item.options[choices[index]].text}}</p>
          </div>
        </div>
      </div>

    <!-- METRICS -->
      <div class="feedback animated fadeIn" v-show="metrics">
        <button class="close" @click="metrics = false"><i class="fas fa-times"></i></button>
        <div class="top">
          <img :src="'media/page3/' + items.activity.scenes[id].image" />
          <div class="right">
            <h2>{{items.activity.scenes[id].title}}</h2>
            <p>{{items.activity.scenes[id].text}}</p>
          </div>
          <slot>

          </slot>
        </div>
        <div class="bottom">
          <div class="fas" :class="{correct: index == best[id]}" v-for="(item, index) in items.activity.scenes[id].options">
            <div class="best" v-show="index == best[id]"><img src="media/page3/best.png" /></div>
            <p>{{item.text}}</p>
            <div class="yours" v-show="index == choices[id]"><p>YOU</p></div>
          </div>
        </div>
      </div>


  </div>
</template>

<script>
export default {
  data() {
    return {
      metrics: false,
      id: 0,
      best: [0, 2, 1, 0, 2, 1],
      step: [false, false, false, false, false, false]
    };
  },

  computed: {
    location() {
      return this.$store.state.scormLMS.location
    },
    items() {
      return this.$store.state.items
    }
  },

  methods: {
    select(num) {
      this.id = num;
      this.metrics = true
      this.step[num] = true
      this.$emit("dashIndex", num);
      this.showCont();
    },
    showCont () {
      function isComplete(el) {
        return (el === true);
      }
      if(this.step.every(isComplete)) {
        this.$store.commit('contTrue')
        this.$store.commit('gameDone')
      }
    }
  },
  mounted() {

  },
  beforeDestroy() {

  },
  components: {},
  props: ['choices']
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Review.vue?6e25dc85